<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search by separation type name"
              single-line
              hide-details
            />
            <v-spacer /><v-spacer />        
            <setup-separations-dialog-create @created="loadTypes" />    
          </v-card-title>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="types"
            :search="search"
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td>{{ props.item.name }}</td>                
                <td>
                  <setup-separations-dialog-edit 
                    :type="props.item"
                    @updated="loadTypes"
                  />  
                  <setup-separations-dialog-delete 
                    :type="props.item"
                    @deleted="loadTypes"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupSeparationsDialogCreate: () => import('@/components/setup/separations/DialogCreate'),
      SetupSeparationsDialogEdit: () => import('@/components/setup/separations/DialogEdit'),
      SetupSeparationsDialogDelete: () => import('@/components/setup/separations/DialogDelete'),
    },
    data () {
      return {
        loading: false,
        search: '',
        headers: [
          {
            text: 'No',
            align: 'left',
            sortable: false,
            value: 'no',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            align: 'left',
            sortable: false,
            value: 'action',
          },
        ],
        types: [],
      }
    },
    created () {
      this.loadTypes()
    },
    methods: {
      loadTypes () {
        this.loading = true

        this.$api.separationTypes().list()
          .then(response => {
            this.types = response.data

            this.loading = false
          })    
      },
    },
  }
</script>
